<template>
  <div class="contentBox">
    <div class="Box-form">
      <el-form
        ref="form"
        label-position="right"
        label-width="auto"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="图片" class="imgform" prop="pic_set">
          <div class="upload">
            <el-upload
              :class="
                form.pic_set.length < 3 ? 'uploadImg' : 'disableUploadImg'
              "
              ref="upload"
              :action="action"
              :headers="uploaderHeader"
              accept=".jpg,.jpeg,.png,.bmp,.gif"
              :limit="3"
              :file-list="filelist"
              list-type="picture-card"
              :on-remove="removePic"
              :on-success="
                (res) => {
                  if (res.code == 0) {
                    form.pic_set.push(res.data.file_fullurl);
                  } else {
                    $message.error(res.msg);
                  }
                }
              "
            >
              <!-- <div slot="tip" class="el-upload__tip">最多可上传3张图片</div> -->
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="tip">最多可上传3张图片</div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="物品名称" prop="goods_name">
              <el-input
                v-model="form.goods_name"
                placeholder="请输入物品名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="物品分类" prop="goods_type_id">
              <el-select
                v-model="form.goods_type_id"
                clearable
                placeholder="请选择物品分类"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="丢失地点" prop="address">
              <el-input
                placeholder="请输入丢失地点"
                v-model="form.address"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="物品描述">
              <el-input
                v-model="form.remark"
                type="textarea"
                placeholder="请输入物品描述"
                :autosize="{ minRows: 4, maxRows: 8 }"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="员工号" class="form-linkman">
              <el-input
                placeholder="请输入员工号"
                v-model="form.linkman_no"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="姓名" class="form-name" prop="linkman">
              <el-input
                placeholder="请输入姓名"
                v-model="form.linkman"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="联系电话" prop="tel">
              <el-input
                placeholder="请输入联系电话"
                v-model="form.tel"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <div class="sub-button">
            <el-button
              type="primary"
              size="small"
              round
              style="
                width: 100%;
                background-color: rgba(50, 88, 159, 1);
                color: #ffffff;
              "
              @click="sub"
              >提交</el-button
            >
          </div>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getLostType, save } from "@/api/pilotService/lostFound";
import { localStorage } from "@/utils/storage";
export default {
  data() {
    return {
      action: this.baseURL + "/webapi/upload/uploadClientPic",
      uploaderHeader: { Authorization: localStorage.get("xy-web-token") },
      form: {
        pic_set: [],
      },
      filelist: [],
      typeOptions: [],
      rules: {
        pic_set: [
          {
            required: true,
            message: "请插入图片",
            trigger: ["blur", "change"],
          },
        ],
        goods_name: [
          {
            required: true,
            message: "请输入物品名称",
            trigger: ["blur", "change"],
          },
        ],
        goods_type_id: [
          {
            required: true,
            message: "请选择物品分类",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入丢失地点",
            trigger: ["blur", "change"],
          },
        ],
        linkman: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        tel: [
          {
            required: true,
            message: "请输入电话",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    load() {
      getLostType()
        .then((res) => {
          if (res.code === 0) {
            this.typeOptions = res.data;
          }
        })
        .catch((err) => {
          ;
        });
    },
    sub() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.pic_set = JSON.stringify(this.form.pic_set);
          save(this.form)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success("发布成功");
                this.form = this.$options.data().form;
                this.filelist = [];
              }
            })
            .catch((err) => {
              ;
            });
        } else {
          return false;
        }
      });
    },
    removePic(file, fileList) {
      let array = new Set(this.form.pic_set);
      array.delete(file.response.data.file_fullurl);
      this.form.pic_set = [...array];
    },
  },
};
</script>

<style scoped>
.contentBox {
  padding: 20px;
  margin-bottom: 40px;
  border-radius: 10px;
  background-color: #ffffff;
}
.upload {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.tip {
  margin-left: 15px;
  font-size: 13px;
}
.uploadImg /deep/ .el-upload,
.disableUploadImg /deep/ .el-upload {
  width: 100px;
  height: 100px;
  position: relative;
}
.uploadImg .el-upload--picture-card i,
.disableUploadImg .el-upload--picture-card i {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.uploadImg /deep/ .el-upload-list--picture-card .el-upload-list__item,
.disableUploadImg /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  position: relative;
}
.el-input {
  width: 100%;
}
.el-textarea {
  width: 100%;
}
.el-select {
  width: 100%;
}
.sub-button {
  width: 30%;
  margin: 0 auto;
}
.disableUploadImg /deep/ .el-upload--picture-card {
  display: none;
}
/* .form-name {
  text-indent: 13px;
}
.form-linkman {
  text-indent: 7px;
} */
@media only screen and (max-width: 768px) {
  /* .contentBox {
    padding: 3%;
  } */
  .imgform /deep/ .el-form-item__label {
    float: none;
  }
  .uploadImg /deep/ .el-upload,
  .disableUploadImg /deep/ .el-upload {
    width: 100px;
    height: 100px;
    position: relative;
  }
  .uploadImg .el-upload--picture-card i,
  .disableUploadImg .el-upload--picture-card i {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .uploadImg /deep/ .el-upload-list--picture-card .el-upload-list__item,
  .disableUploadImg /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  .el-icon-plus {
    width: 40%;
  }
  .sub-button {
    width: 50%;
  }
}
</style>